if (!customElements.get('kr8-film')) {
  customElements.define('kr8-film', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const error = this.querySelector('[role="status"]');
      if (!video || !button) return;
      video.setAttribute('aria-label', this.closest('.kr8-behind')?.querySelector('h2')?.textContent || 'Krelune film');
      button.hidden = false;
      button.addEventListener('click', async () => {
        button.disabled = true;
        error.hidden = true;
        try {
          await video.play();
          button.hidden = true;
          video.focus();
        } catch (_) {
          button.hidden = false;
          error.hidden = false;
        } finally {
          button.disabled = false;
        }
      }, {signal});
      video.addEventListener('play', () => {
        button.hidden = true;
        error.hidden = true;
        document.querySelectorAll('video').forEach(other => {
          if (other !== video && !other.paused) other.pause();
        });
      }, {signal});
      video.addEventListener('ended', () => { button.hidden = false; }, {signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
